export default __webpack_public_path__ + "static/media/campos.a892ce42.jpg";